import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	filtersTitle: {
		id: 'company-hub.search-extension.custom-search-config-panel.filters-title',
		defaultMessage: 'Filters',
		description:
			'A visible text label to be used as the title for the custom search config panel filters section',
	},
});
